import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AssistanceScreening from "@/components/AssistanceScreening";
import { t } from "@/lib/i18n";

export default function Assistance() {
  const [latest, setLatest] = useState(undefined);

  useEffect(() => {
    api.get("/readings")
      .then(({ data }) => setLatest(data[0] || null))
      .catch(() => setLatest(null));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-12 space-y-8" data-testid="assistance-page">
      <div className="fade-up">
        <p className="eyebrow">{t("Mitigation assistance")}</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-2 text-[#1C201F] leading-tight">
          {t("Help paying for radon mitigation")}
        </h1>
        <p className="text-[#5C6661] mt-2 max-w-2xl">
          {t("Answer a few quick questions to see if your household may qualify for help covering the cost of a radon mitigation system.")}
        </p>
      </div>
      <div className="fade-up delay-1">
        {latest === undefined ? (
          <div className="eyebrow text-[#5C6661]" data-testid="assistance-page-loading">{t("Loading…")}</div>
        ) : (
          <AssistanceScreening latestReading={latest} />
        )}
      </div>
    </div>
  );
}
